import React,{ useState } from 'react';
import { Modal } from 'react-bootstrap';
import Tradingviews from '../Component/Charts/tradingviews';

function Tradingmodal(props) {

    const [trademodal, setTrademodal] = useState(true);

  return (
    <div>
     <Modal
       show={trademodal}
       size="xl"
       aria-labelledby="contained-modal-title-vcenter"
       centered
     >
      <Modal.Header closeButton onClick={props.onDismiss}></Modal.Header>
      <Modal.Body>
        <h4 className='d_white mb-2'>Technical Analysis</h4>
            <Tradingviews/>
      </Modal.Body>
     </Modal>

    </div>
  )
}

export default Tradingmodal